import styled from 'styled-components'

export const GlobalTable = styled.table`
  min-height: fit-content;
  width: fit-content;
  min-width: 100%;
  text-align: start;
  border-collapse: collapse;

  tr:nth-child(2) td:first-child {
    border-top-left-radius: 0.5rem;
  }

  tr:nth-child(2) td:last-child {
    border-top-right-radius: 0.5rem;
  }

  tr:last-child td:first-child {
    border-bottom-left-radius: 0.5rem;
  }

  tr:last-child td:last-child {
    border-bottom-right-radius: 0.5rem;
  }

  tr:last-child {
    border: none;
  }
`

export const HeaderLine = styled.tr`
  position: sticky;
  top: 0;
  height: 4rem;
  z-index: 1;
`

export const ConfigButton = styled.button`
  position: absolute;
  height: 100%;
  right: 0;
  outline: none;
  color: #c0c0c0;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: rgba(0, 0, 0, 0);
`

export const Th = styled.th`
  color: #696969;
  background-color: #f5f5f5;
  text-align: start;
  border: 0;
  font-size: 0.85rem;
  font-weight: 400;
  padding-left: 1.2rem;
`

export const Tr = styled.tr`
  height: 4.5rem;
  border-bottom: solid 1px #ebebeb;
  border-radius: 1rem;
  background-color: #fff;
  &.yellowLine {
    background-color: #fffcee;
    color: #9d7d07;
    &:hover {
      background-color: rgba(229, 213, 140, 0.34);
    }
  }

  &.greenLine {
    background-color: #e8f7ec;
    color: rgba(97, 204, 122, 0.5);
    &:hover {
      background-color: #f7f7f7;
    }
  }

  &:hover {
    background-color: #f7f7f7;

    .edit-div {
      visibility: visible;
    }
  }
`

export const FooterTr = styled.tr`
  background-color: transparent;
  border: none;
  height: auto;

  &:hover {
    background-color: transparent;
  }
`

export const Td = styled.td`
  width: 20rem;
  text-align: start;
  font-size: 14px;
  padding-left: 1.2rem;
  word-wrap: break-word;
  overflow-wrap: break-word;
`

export const DivInTd = styled.div`
  display: flex;
  gap: 0.3rem;
  align-items: center;

  .documentUrl {
    cursor: pointer;
    &:hover {
      color: #0090d3;
    }
  }
`

export const TdButtons = styled.td`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  height: 4.5rem;
  width: fit-content;
  padding-right: 1rem;
`

